"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ESports = void 0;
var ESports;
(function (ESports) {
    ESports[ESports["Basketball"] = 1016] = "Basketball";
    ESports[ESports["BeachVolleyball"] = 1017] = "BeachVolleyball";
    ESports[ESports["Cricket"] = 1021] = "Cricket";
    ESports[ESports["Soccer"] = 1023] = "Soccer";
    ESports[ESports["IceHockey"] = 1027] = "IceHockey";
    ESports[ESports["HandBall"] = 1028] = "HandBall";
    ESports[ESports["Tennis"] = 1034] = "Tennis";
    ESports[ESports["TableTennis"] = 1033] = "TableTennis";
    ESports[ESports["Volleyball"] = 1035] = "Volleyball";
    ESports[ESports["Basketbal3X3"] = 1181] = "Basketbal3X3";
    ESports[ESports["CyberSports"] = 1202] = "CyberSports";
    ESports[ESports["Fifa"] = 1449] = "Fifa";
    ESports[ESports["ENHL"] = 1450] = "ENHL";
    ESports[ESports["ENBA"] = 1451] = "ENBA";
    ESports[ESports["Futsal"] = 1103] = "Futsal";
    ESports[ESports["Snooker"] = 1036] = "Snooker";
    ESports[ESports["Badminton"] = 1014] = "Badminton";
    ESports[ESports["Squash"] = 1107] = "Squash";
    ESports[ESports["Kabaddi"] = 1174] = "Kabaddi";
    ESports[ESports["Baseball"] = 1015] = "Baseball";
    ESports[ESports["AmericanFootball"] = 1012] = "AmericanFootball";
    ESports[ESports["AussieRules"] = 1013] = "AussieRules";
    ESports[ESports["Rugby"] = 1031] = "Rugby";
    ESports[ESports["BeachSoccer"] = 1112] = "BeachSoccer";
    ESports[ESports["Boxing"] = 1020] = "Boxing";
    ESports[ESports["Darts"] = 1022] = "Darts";
    ESports[ESports["Waterpolo"] = 1042] = "Waterpolo";
    ESports[ESports["Chess"] = 1109] = "Chess";
    ESports[ESports["FieldHockey"] = 1126] = "FieldHockey";
    ESports[ESports["Pesapallo"] = 1127] = "Pesapallo";
    ESports[ESports["MMA"] = 1179] = "MMA";
})(ESports || (exports.ESports = ESports = {}));
